<template>
    <div class="loading-area">
        <div class="loading-wrapper">
            <LoadingMark>
            </LoadingMark>
        </div>
    </div>
</template>
<script>
	import LoadingMark from '@/components/LoadingMark';

	export default {
		mixins: [],
		components: {
			LoadingMark,
		},
	};
</script>
<style lang="scss" scoped>
.loading-area {
	display: flex;
	align-items: center;
	justify-content: center;

	position: fixed;
	background-color: rgba(0,0,0,0.1);
	top: 0;
	left: 0;
	z-index: 99999;
	height: 100%;
	width: 100%;
	.loading-wrapper {
		height: 50px;
		width: 50px;
	}
}

</style>